/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Countryselector_Searchcountries2Inputs */

const id_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari negara...`)
};

const ms_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari negara...`)
};

const da_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter lande...`)
};

const de_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länder durchsuchen...`)
};

const en_us2_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

const es_es2_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar países...`)
};

const es_mx2_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar países...`)
};

const fil_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga bansa...`)
};

const fr_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des pays…`)
};

const it_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca paesi...`)
};

const hu_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Országok keresése...`)
};

const nl_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek landen...`)
};

const no_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter land...`)
};

const pl_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj krajów...`)
};

const pt_br2_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

const pt_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar países...`)
};

const ro_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută țări...`)
};

const fi_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae maita...`)
};

const sv_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök länder...`)
};

const vi_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm quốc gia...`)
};

const tr_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülkeleri ara...`)
};

const cs_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat země...`)
};

const bg_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на държави...`)
};

const ru_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск стран...`)
};

const uk_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук країн...`)
};

const ar_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن دول...`)
};

const hi_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश खोजें...`)
};

const th_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาประเทศ...`)
};

const ja_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国を検索...`)
};

const zh_cn2_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

const zh_hant1_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

const ko_components_countryselector_searchcountries2 = /** @type {(inputs: Components_Countryselector_Searchcountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search countries...`)
};

/**
* | output |
* | --- |
* | "Search countries..." |
*
* @param {Components_Countryselector_Searchcountries2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_countryselector_searchcountries2 = /** @type {((inputs?: Components_Countryselector_Searchcountries2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Countryselector_Searchcountries2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_countryselector_searchcountries2(inputs)
	if (locale === "ms") return ms_components_countryselector_searchcountries2(inputs)
	if (locale === "da") return da_components_countryselector_searchcountries2(inputs)
	if (locale === "de") return de_components_countryselector_searchcountries2(inputs)
	if (locale === "en-US") return en_us2_components_countryselector_searchcountries2(inputs)
	if (locale === "es-ES") return es_es2_components_countryselector_searchcountries2(inputs)
	if (locale === "es-MX") return es_mx2_components_countryselector_searchcountries2(inputs)
	if (locale === "fil") return fil_components_countryselector_searchcountries2(inputs)
	if (locale === "fr") return fr_components_countryselector_searchcountries2(inputs)
	if (locale === "it") return it_components_countryselector_searchcountries2(inputs)
	if (locale === "hu") return hu_components_countryselector_searchcountries2(inputs)
	if (locale === "nl") return nl_components_countryselector_searchcountries2(inputs)
	if (locale === "no") return no_components_countryselector_searchcountries2(inputs)
	if (locale === "pl") return pl_components_countryselector_searchcountries2(inputs)
	if (locale === "pt-BR") return pt_br2_components_countryselector_searchcountries2(inputs)
	if (locale === "pt") return pt_components_countryselector_searchcountries2(inputs)
	if (locale === "ro") return ro_components_countryselector_searchcountries2(inputs)
	if (locale === "fi") return fi_components_countryselector_searchcountries2(inputs)
	if (locale === "sv") return sv_components_countryselector_searchcountries2(inputs)
	if (locale === "vi") return vi_components_countryselector_searchcountries2(inputs)
	if (locale === "tr") return tr_components_countryselector_searchcountries2(inputs)
	if (locale === "cs") return cs_components_countryselector_searchcountries2(inputs)
	if (locale === "bg") return bg_components_countryselector_searchcountries2(inputs)
	if (locale === "ru") return ru_components_countryselector_searchcountries2(inputs)
	if (locale === "uk") return uk_components_countryselector_searchcountries2(inputs)
	if (locale === "ar") return ar_components_countryselector_searchcountries2(inputs)
	if (locale === "hi") return hi_components_countryselector_searchcountries2(inputs)
	if (locale === "th") return th_components_countryselector_searchcountries2(inputs)
	if (locale === "ja") return ja_components_countryselector_searchcountries2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_countryselector_searchcountries2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_countryselector_searchcountries2(inputs)
	return ko_components_countryselector_searchcountries2(inputs)
});
export { components_countryselector_searchcountries2 as "components.countrySelector.searchCountries" }